import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { VCN_MANAGEMENT_QUERY_KEY } from './useVcnManagementList'
import { VCN_MANAGEMENT_CARD_QUERY_KEY } from './useVcnManagementCardList'
import { VCN_MIGRATION_SUMMARY_QUERY_KEY } from './useVcnMigrationSummary'
import { VCN_CARD_METRICS_QUERY_KEY } from './useVcnCardMetrics'
import { EMPLOYEE_VCN_CARDS_QUERY_KEY } from './useEmployeeVcnCards'

/**
 * Invalidates everything a VCN action can change, from either tab.
 *
 * Shared because the caller is not always the tab that owns the data: a bulk
 * terminate started in Benefit Mode changes the same cards Card Mode lists, and
 * the job can reach a terminal state while the user is on the other tab. Five
 * separate queries, so missing one leaves a view serving pre-action numbers or
 * rows for the length of its staleTime.
 */
export function useInvalidateVcnData(): () => void {
  const queryClient = useQueryClient()

  return useCallback(() => {
    for (const queryKey of [
      VCN_MANAGEMENT_QUERY_KEY,
      VCN_MANAGEMENT_CARD_QUERY_KEY,
      VCN_MIGRATION_SUMMARY_QUERY_KEY,
      VCN_CARD_METRICS_QUERY_KEY,
      // Any open "Associated VCNs" panel is its own query and would otherwise
      // stay stale after Refresh / bulk / toolbar actions.
      EMPLOYEE_VCN_CARDS_QUERY_KEY,
    ]) {
      void queryClient.invalidateQueries({ queryKey: [queryKey] })
    }
  }, [queryClient])
}
